import React from 'react';
import Button from '@material-ui/core/Button';
import sanitizeDepartment from 'utils/models/sanitizeDepartment';
import InputField from 'components/pure/utils/form/InputField';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import Dialog from 'components/pure/utils/Dialog';
import './CreateDepartmentDialog.styl';

export default class CreateDepartmentDialog extends React.PureComponent {
  hasErrors() {
    return !!this.props.errors;
  }

  getError(prop) {
    return this.props.errors &&
      this.props.errors[prop] &&
      (this.props.touchedFields.includes(prop) || this.props.wasSubmitRequested)
      ? this.props.errors[prop][0]
      : null;
  }

  onSubmit = () => {
    this.props.requestSubmit();
    if (!this.hasErrors()) {
      this.props.createDepartment(sanitizeDepartment(this.props.department));
    }
  };

  render() {
    return (
      <Dialog
        title="Add New Department"
        closeButton={true}
        className="create-department-dialog form-container"
        actions={[
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            onClick={this.onSubmit}
            disabled={this.props.isDepartmentSaving}>
            Create
          </Button>,
          <Button
            variant="outlined"
            className="ev-button"
            onClick={this.props.closeCreateDialog}
            onMouseDown={
              /* prevent blur event */
              e => e.preventDefault()
            }
            disabled={this.props.isDepartmentSaving}>
            Cancel
          </Button>,
        ]}
        open={true}
        onRequestClose={this.props.closeCreateDialog}>
        <FieldContainer label="Name" error={this.getError('name')}>
          <InputField
            placeholder="Name"
            focused={true}
            onBlur={() => this.props.fieldTouched('name')}
            onChange={val => this.props.editDepartment('name', val)}
            value={this.props.department.name || ''}
          />
        </FieldContainer>
      </Dialog>
    );
  }
}
